<div class="image-rotator">
    <ul class="image-items">
        <li class="image-item"
            *ngFor="let image of images; let i = index"
            (swipeleft)="swipe(i, $event.type)"
            (swiperight)="swipe(i, $event.type)"
            [class.current]="image.isCurrent">
            <a [attr.href]="image.landingUrl || null" target="_blank">
                <picture>
                    <source srcset="{{ image.smallImageUrl }}" media="(max-width: {{ maxSmallSize }})">
                    <source srcset="{{ image.mediumImageUrl }}" media="(max-width: {{ maxMediumSize }})">
                    <source srcset="{{ image.largeImageUrl }}">
                    <img [attr.src]="image.defaultImageUrl || image.smallImageUrl"
                         [attr.alt]="image.caption">
                </picture>
            </a>
        </li>
    </ul>
    <div class="previous"
         *ngIf="isMultipleImages"
         [attr.disabled]="currentImageIndex === 0 ? '' : null">
        <a href="#" class="icon" (click)="showPreviousImage($event)">
            <mat-icon>chevron_left</mat-icon>
        </a>
    </div>
    <div class="next"
         *ngIf="isMultipleImages"
         [attr.disabled]="currentImageIndex === images.length - 1 ? '' : null">
        <a href="#" class="icon" (click)="showNextImage($event)">
            <mat-icon>chevron_right</mat-icon>
        </a>
    </div>
    <ul class="image-counters" *ngIf="isMultipleImages">
        <li class="image-counter"
            *ngFor="let image of images; let i = index"
            [class.current]="image.isCurrent"
            (click)="setCurrentImage(i)"></li>
    </ul>
</div>
